module.exports = __webpack_public_path__ + "img/qrcode.b00d2fe3.png";